import React, { Component } from 'react';
import jquery from 'jquery';

export class BadgeSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hosting: 'github',
      project: 'bob-bench/benchupload',
      branch:  'master',
      ci:      'travis-ci',
      format:  'Markdown',
    };
    this.changeHosting = this.changeEvent.bind(this, 'hosting');
    this.changeCi = this.changeEvent.bind(this, 'ci');
    this.changeProject = this.changeEvent.bind(this, 'project');
    this.changeBranch = this.changeEvent.bind(this, 'branch');
    this.changeFormat = this.changeEvent.bind(this, 'format');
  }

  changeEvent(field, e) {
    var newState = {};
    newState[field] = e.target.value;
    this.setState(newState);
  }

  buildImageUrl() {
    return 'https://api.bob-bench.org/v1/badgeByUrl?' + jquery.param({
        branch: this.state.branch,
        hosting: this.state.hosting,
        ci: this.state.ci,
        repo: this.state.project,
        subNumber: 1});
  }

  formatUrl(url) {
    if (this.state.format === "Markdown")
      return "[![Test Status](" + url + ")](https://bob-bench.org/r/gh/" + this.state.project +")"
    if (this.state.format === 'AsciiDoc')
      return "image:" + url + '["Test Status",link="https://bob-bench.org/r/gh/' + this.state.project + '"]';
    return url;
  }

  render() {
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
          <p>Using hosted CI services like <a href="http://travis-ci.org">travis-ci
          </a> or <a href="http://circleci.com">circleci</a> but want to collect
          metrics such as filesize, download size of your mobile app, test execution
          time or test results across builds? Upload, analyze and visualize Free and
          OpenSource Software metrics and test results.</p>
          <p>Read our <a
	  href="http://benchupload.readthedocs.io/en/latest/">documentation</a> on
          how to upload test results and use this page to generate a badge for
          your <i>README.md</i>. You can browse an example result <a
	  href="/r/gh/bob-bench/xunit-parser">here</a>.</p>
          </div>
        </div>
        {this.renderForm()}
      </div>);
  }

  renderForm() {
    var imageUrl = this.buildImageUrl();
    var display = this.formatUrl(imageUrl);
    return (
      <div className="row"><div className="col-md-9">
        <h2>Create a badge for your project</h2>
        <form onSubmit={this.handleSubmit} className="form-horizonal">
          {/* Github or maybe gitlab and bitbucket in the future */}
          <div className="form-group">
            <label className="col-sm-2 control-label">Hosting</label>
            <div className="col-sm-10">
              <select name="hosting" value={this.state.hosting} onChange={this.changeHosting} className="form-control">
                <option value="github">Github</option>
              </select>
            </div>
          </div>
          {/* CI system used, e.g. travis-ci or circleci */}
          <div className="form-group">
            <label className="col-sm-2 control-label">CI</label>
            <div className="col-sm-10">
              <select name="ci" value={this.state.ci} onChange={this.changeCi} className="form-control">
                <option value="travis-ci">Travis CI</option>
                <option value="circleci">CircleCI</option>
              </select>
            </div>
          </div>
          {/* The project name on the hosting platform */}
          <div className="form-group">
            <label className="col-sm-2 control-label">Project</label>
            <div className="col-sm-10">
              <input type="text" value={this.state.project} name="project" className="form-control" onChange={this.changeProject} />
            </div>
          </div>
          {/* The branch to use */}
          <div className="form-group">
            <label className="col-sm-2 control-label">Branch</label>
            <div className="col-sm-10">
              <input type="text" name="branch" value={this.state.branch} className="form-control" onChange={this.changeBranch} />
            </div>
          </div>
          {/* The output format */}
          <div className="form-group">
            <label className="col-sm-2 control-label">Format</label>
            <div className="col-sm-10">
              <select value={this.state.format} name="format" className="form-control" onChange={this.changeFormat}>
                <option value="Markdown">Markdown</option>
                <option value="Image URL">Image URL</option>
                <option value="AsciiDoc">AsciiDoc</option>
              </select>
            </div>
          </div>
          <div className="form-group">
            <label className="col-sm-2 control-label">Markup</label>
            <div className="col-sm-10">
              <textarea readOnly className="col-sm-12" value={display} />
            </div>
          </div>
          <div className="form-group">
            <label className="col-sm-2 control-label">Image</label>
            <div className="col-sm-10">
              <a href={"/r/gh/" + this.state.project}>
                <img alt="Badge of specified project" src={imageUrl} />
              </a>
            </div>
          </div>
        </form>
      </div></div>);
  }
}





// WEBPACK FOOTER //
// ./src/views/BadgeSelector.js